import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const Hero = () => {
  useEffect(() => {
    Aos.init({
      duration: 1200,
      once: false,
    });
  }, []);

  return (
    <section
      id="home"
      className="relative bg-cover bg-center bg-white text-black snap-start snap-mandatory overflow-hidden min-h-screen pt-28"
      style={{ backgroundImage: `url('/hero-bg.jpg')` }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        
        {/* Left Text Section */}
        <div data-aos="fade-up" className="space-y-6 mt-10 md:mt-0 font-roboto">
          <h1 className="text-3xl sm:text-lg lg:text-7xl font-bold leading-tight text-sky-500">
            Empowering Your <br />
            <span className="text-white">IT Infrastructure</span>
          </h1>
          <p className="text-sm sm:text-2xl text-blue-50">
            At <span className="text-sky-400 text-3xl font-semibold">Sairaj Infotech</span>, we deliver modern IT solutions and infrastructure services 
            that help your business thrive in the digital age.
          </p>
          <p className="text-base sm:text-2xl text-blue-50">
            Delivering secure, scalable, and smart IT solutions since 2010.
          </p>
          <p className="text-lg sm:text-4xl font-bold text-sky-400">
            <span className="text-3xl sm:text-5xl font-bold">50+</span> Happy Clients
          </p>
        </div>

        
      </div>
    </section>
  );
};

export default Hero;
